import { commaListSchema } from "@birdwatch/common";
import { z } from "zod";

import {
  filterSearchFragment,
  notificationSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

/**
 * `validateSearch` for every place list tab — `/office/places/active` and
 * `/all`. The tabs differ only in the data they request, never in the URL keys
 * they accept: TanStack validates with the CURRENT route's schema and
 * `z.object` strips unknown keys, so a key declared on one tab but not another
 * is silently dropped and its writer just looks dead on the other tab.
 */
export const placeListSearchSchema = z.object({
  search: z.string().optional(),
  ...filterSearchFragment,
  filters: z
    .object({
      types: withOperators(commaListSchema),
      status: withOperators(z.string().optional()),
      planKey: withOperators(commaListSchema),
      accountIds: withOperators(commaListSchema),
      locationIds: withOperators(commaListSchema),
      // Lenient (webapp-routing.md): a stale or hand-typed value must not crash the page.
      hasEvaluation: withOperators(z.string().optional()),
      ...notificationSearchFragment,
    })
    .optional(),
  sort: z.string().optional(),
  ...maskSearchFragment,
});
